import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function IncludesSection() {
  const includes = ['Las 6 plantillas (Sheet Pan, Tacos/Bowls, Pasta Rápida, Breakfast-for-Dinner, One-Pot, Freezer + Salad)', 'Cómo construir tu lista maestra en 30 minutos', 'Groceries 1x/semana con listas modulares imprimibles', 'Rituales de 10 minutos para que la semana corra sola', 'Plan B: un menú de emergencia sin culpa para cuando no puedes'];
  const forYouIf = ['llegas cansado y odias decidir de noche', 'terminas en takeout por agotamiento, no por gusto', 'quieres comer más "en casa" sin convertirlo en un proyecto', 'quieres orden, no inspiración'];
  const notForYouIf = ['buscas recetas gourmet diarias', 'necesitas un plan médico/terapéutico específico', 'quieres contar macros con precisión clínica'];
  const expectations = ['menos fricción en casa', 'menos "ya qué, pidamos algo"', 'más calma a las 7 pm', 'más control sin esfuerzo heroico'];
  return <section className="w-full bg-white py-20 lg:py-28" data-id="element-82">
      <div className="max-w-6xl mx-auto px-6 lg:px-12" data-id="element-83">
        {/* What's Included */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-20" data-id="element-84">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8" data-id="element-85">
            Qué incluye exactamente
          </h2>

          <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-86">
            Dentro del PDF vas a encontrar:
          </p>

          <div className="space-y-4" data-id="element-87">
            {includes.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start bg-stone-50 p-6 rounded-lg" data-id="element-88">
                <CheckCircleIcon className="w-6 h-6 text-lime-600 mr-4 flex-shrink-0 mt-1" data-id="element-89" />
                <span className="text-lg text-gray-800 leading-relaxed" data-id="element-90">
                  {item}
                </span>
              </motion.div>)}
          </div>
        </motion.div>

        {/* Who It's For */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-20" data-id="element-91">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12" data-id="element-92">
            Para quién es (y para quién no)
          </h2>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-93">
            {/* For You If */}
            <div className="bg-lime-50 p-8 rounded-lg" data-id="element-94">
              <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-95">
                Esto es para ti si:
              </h3>
              <div className="space-y-4" data-id="element-96">
                {forYouIf.map((item, index) => <div key={index} className="flex items-start" data-id="element-97">
                    <CheckCircleIcon className="w-5 h-5 text-lime-600 mr-3 flex-shrink-0 mt-1" data-id="element-98" />
                    <span className="text-gray-800 leading-relaxed" data-id="element-99">
                      {item}
                    </span>
                  </div>)}
              </div>
            </div>

            {/* Not For You If */}
            <div className="bg-stone-50 p-8 rounded-lg" data-id="element-100">
              <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-101">
                No es para ti si:
              </h3>
              <div className="space-y-4" data-id="element-102">
                {notForYouIf.map((item, index) => <div key={index} className="flex items-start" data-id="element-103">
                    <XCircleIcon className="w-5 h-5 text-gray-400 mr-3 flex-shrink-0 mt-1" data-id="element-104" />
                    <span className="text-gray-700 leading-relaxed" data-id="element-105">
                      {item}
                    </span>
                  </div>)}
              </div>
            </div>
          </div>
        </motion.div>

        {/* What to Expect */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-stone-50 p-8 lg:p-12 rounded-lg" data-id="element-106">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-107">
            Lo que puedes esperar sentir (rápido)
          </h2>

          <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-108">
            No voy a prometerte que tu vida se vuelve perfecta.
          </p>

          <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-109">
            Pero sí pasa algo muy específico cuando dejas de decidir todas las
            noches:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-110">
            {expectations.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="bg-white p-6 rounded-lg shadow-sm" data-id="element-111">
                <div className="flex items-center" data-id="element-112">
                  <div className="w-2 h-2 bg-lime-600 rounded-full mr-3" data-id="element-113"></div>
                  <span className="text-lg text-gray-800 font-medium" data-id="element-114">
                    {item}
                  </span>
                </div>
              </motion.div>)}
          </div>

          <p className="text-xl font-semibold text-gray-900 mt-8" data-id="element-115">
            Y eso vale mucho más que una receta nueva.
          </p>
        </motion.div>
      </div>
    </section>;
}